module.exports = __webpack_public_path__ + "static/media/gray-clock-icon.2be3ec1a.svg";